import { Flex } from '@chakra-ui/react';
import Hero from '@components/features/landing-pages/BaseHero';
import Button from '@components/interactive/Button';
import DefaultLayout from '@components/layout/layout/DefaultLayout';
import News from '../index/fsm/News';
import Reviews from '../index/fsm/Reviews';
import WhatToExpect from '../index/fsm/WhatToExpect';
import BillOfRights from './BillOfRights';
import CallUs from './CallUs';
import Clients from '../index/fsm/Clients';
import FAQS from './FAQS';
import HeroSubheading from './HeroSubheading';

const ACA = () => (
  <DefaultLayout>
    <Hero
      header="Your unbiased advisor to ACA"
      subheader={HeroSubheading()}
      renderCta={() => (
        <Flex w="100%" maxW="450px">
          <Button className="call-us-button" href="tel:888-401-7257" width="100%" fontSize={18} letterSpacing=".5px">
            Call Us: 888-401-7257
          </Button>
        </Flex>
      )}
    />
    <Reviews />
    <Clients />
    <BillOfRights />
    <WhatToExpect />
    <News />
    <FAQS />
    <CallUs />
  </DefaultLayout>
);

export default ACA;
